import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { EntityValue, EntityValueCreate } from "@/model";
import entityValueRepository from "@/repository/entityValueRepository";
import { entityQueryKeys } from "@/query/entity";
import { entityValueQueryKeys } from "./keys";


export const useCreateEntityValue = (agentId: number, entityId: string) => {
    const queryClient = useQueryClient();

    return useMutation<EntityValue, AxiosError, EntityValueCreate>({
        mutationKey: ["entity-value", "create", agentId, entityId],
        mutationFn: async (form: EntityValueCreate) => {
            try {
                const { data } = await entityValueRepository.create(agentId, entityId, form);
                return data.result;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: entityQueryKeys.recent(agentId),
                exact: false
            });
            await queryClient.invalidateQueries({
                queryKey: entityValueQueryKeys.pageAll(agentId, entityId)
            });
        }
    });
};
